export default function ({ $auth, redirect, app, route }) {
  if ($auth.user) {
    // Someone who set out to write to us about their account belongs on the
    // form that can answer them, not on the default landing page.
    return redirect(app.localePath(route.query.to === 'contact' ? '/contact' : '/users'))
  }
}
